import WarningIcon from '@mui/icons-material/Warning'
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material'
import React, { FunctionComponent, useState } from 'react'

import { useFormActionButtonStyles } from '../helpers'

type DeleteWithConfirmationProps = {
  actionButtonText?: string
  disabled?: boolean
  onConfirm?: () => Promise<void>
  overrideOpenState?: { open: boolean; setOpen: (v: boolean) => void }
}

export const DeleteWithConfirmation: FunctionComponent<DeleteWithConfirmationProps> = ({
  actionButtonText,
  children,
  disabled,
  onConfirm,
  overrideOpenState,
}) => {
  const [deleteConfirmLocalOpen, setDeleteConfirmLocalOpen] = useState(false)
  const setDeleteConfirmOpen = (v: boolean): void => {
    overrideOpenState ? overrideOpenState.setOpen(v) : setDeleteConfirmLocalOpen(v)
  }
  const deleteConfirmOpen = overrideOpenState ? overrideOpenState.open : deleteConfirmLocalOpen
  return (
    <>
      <Button
        sx={useFormActionButtonStyles}
        variant="outlined"
        type="button"
        onClick={() => setDeleteConfirmOpen(true)}
        disabled={disabled}
      >
        {actionButtonText || 'Löschen'}
      </Button>
      <Dialog open={deleteConfirmOpen} aria-labelledby="delete-confirm-title">
        <DialogTitle
          sx={{
            color: theme => theme.palette.error.main,
            display: 'flex',
            alignItems: 'center',
          }}
          id="delete-confirm-title"
        >
          <WarningIcon />
          <Box ml={1}>
            <Typography variant="h6" component="h2">
              Achtung!
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>{children}</DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={() => setDeleteConfirmOpen(false)}>
            Abbrechen
          </Button>
          <Button
            onClick={async () => {
              await onConfirm?.()
              setDeleteConfirmOpen(false)
            }}
          >
            {actionButtonText || 'Löschen'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
